import { CheckScreen } from '@/components/Biometric/FaceCheckScreen/screens';
import { BiometricCheckErrorResponse } from '@/model/BiometricCheckErrorResponse';
import { PostMessageCheckRequest } from '@/model/PostMessageCheckRequest';
import { SearchFaceByImageResponse } from '@/model/SearchFaceByImageResponse';
import React, { JSX } from 'react';

interface StateProps {
  request?: PostMessageCheckRequest;
}

interface DispatchProps {
  onAnalysisComplete: (data: SearchFaceByImageResponse[]) => void;
  onAnalysisError: (data: BiometricCheckErrorResponse) => void;
}

type Props = StateProps & DispatchProps;

export const BiometriChangePassword: React.FC<Props> = ({
  request,
  onAnalysisComplete,
  onAnalysisError,
}): JSX.Element => (
  <div className="flex flex-col justify-center text-center font-dmsans">
    {request && (
      <CheckScreen
        request={request}
        onAnalysisComplete={onAnalysisComplete}
        onAnalysisError={onAnalysisError}
      />
    )}
  </div>
);
